<template>
    <div>
        <h1 class="display-heading">Newsletter History</h1>

        <div class="mb-3">
            <div class="mb-1">
                <b>Email Subject</b>
            </div>
            <p>
                {{ emailSubject }}
            </p>
        </div>
        <div class="mb-3">
            <div class="mb-1">
                <b>Sent At</b>
            </div>
            <p>
                {{ addedAt }}
            </p>
        </div>
        <div class="mb-3">
            <div class="mb-1">
                <b>Total Recipients</b>
            </div>
            <p>
                {{ recipientCount }}
            </p>
        </div>

        <div class="mb-3">
            <div class="mb-1">
                <b>Email Content</b>
            </div>
            <div class="card">
                <div class="card-body">
                        <div v-html="emailContent"></div>
                </div>
            </div>
        </div>

        <div class="mb-3">
            <div class="mb-1">
                <b>Recipient List</b>
            </div>
            <div>
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="50">
                        <col>
                        <col>
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email Address</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(recipient, index) in recipients" :key="index">
                            <td>
                                {{ index + 1 }}
                            </td>
                            <td>
                                {{ recipient.recipientName }}
                            </td>
                            <td>
                                {{ recipient.recipientEmailAddress }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div>
            <router-link :to="{'name': 'newsletter-history'}" class="btn btn-primary btn-primary-insv">
                Back to List
            </router-link>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDateTime
} from '@/utilities';
export default {
    'name': 'NewsletterHistoryDetail',
    'computed': {
        newsletterId () {
            return this.$route.params.id;
        }
    },
    data () {
        return {
            'addedAt': null,
            'emailSubject': null,
            'emailContent': null,
            'recipientCount': 0,
            'recipients': []
        };
    },
    mounted () {
        this.getNewsletter();
    },
    'methods': {
        getNewsletter () {
            this.axios.get('Newsletter/SentRequest', {
                'params': {
                    'requestId': this.newsletterId
                }
            }).then(({ data }) => {
                if (data.data) {
                    const newsletter = data.data;

                    this.addedAt = convertToUserReadableDateTime(newsletter.addedAt);
                    this.emailSubject = newsletter.emailSubject;
                    this.emailContent = newsletter.emailContent;
                    this.recipientCount = newsletter.recipientCount;
                    this.recipients = newsletter.recipients;
                }
            });
        }
    }
};
</script>
